import React, { useState, useEffect } from "react";
import { baseURL } from "./backend_url";
import axios from "axios";
import Swal from "sweetalert2";
import { formatDate_withTime } from "./commonFunctions";
// import notificationSound from "./assets/notification.mp3"; // Ensure to add a sound file
import { useLocation } from "react-router-dom";

function RequestVehicle({ setNewTicketCount, allTickets, setAllTickets }) {
  const [editedTickets, setEditedTickets] = useState({});
  const [ticketStatusFilter, setTicketStatusFilter] = useState("Open");
  const [userType, setUserType] = useState("");
  const [access, setAccess] = useState("Edit");
  const location = useLocation();

  useEffect(() => {
    const loggedInUser = sessionStorage.getItem("user_token");
    const foundUser = JSON.parse(loggedInUser);
    if ("Users" === foundUser.role) {
      setAccess(foundUser.access["DriverApp_Access Specifier"]);
      setUserType(foundUser.role);
    }

    // Check if we have a ticketId in the location state
    const ticketId = location.state?.ticketId;
    if (ticketId) {
      // Find the ticket in allTickets
      const ticket = allTickets.find(t => t._id === ticketId);
      if (ticket) {
        // Scroll to the ticket
        setTimeout(() => {
          const element = document.getElementById(`ticket-${ticketId}`);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            element.classList.add('highlight');
            setTimeout(() => element.classList.remove('highlight'), 3000);
          }
        }, 100);
      }
    }
  }, [location, allTickets]);

  const handleStatusChange = (ticketId, newStatus) => {
    setEditedTickets({
      ...editedTickets,
      [ticketId]: newStatus,
    });
  };

  const handleSaveChanges = () => {
    const updatedTickets = allTickets.map((ticket) => {
      if (editedTickets[ticket._id]) {
        return {
          ...ticket,
          ticket_status: editedTickets[ticket._id] === "Requested",
        };
      }
      return ticket;
    });

    axios
      .post(baseURL + "/srt_update_tickets", { tickets: updatedTickets })
      .then((response) => {
        Swal.fire("Success", "Ticket status updated successfully", "success");
        setAllTickets(updatedTickets);
        setEditedTickets({});
        setNewTicketCount(0); // Reset notification count after saving changes
      })
      .catch((error) => {
        Swal.fire("Error", "Failed to update ticket statuses", "error");
      });
  };

  const filteredTickets = allTickets.filter((ticket) => {
    if (ticketStatusFilter === "") return true;
    return ticketStatusFilter === "Open"
      ? ticket.ticket_status
      : !ticket.ticket_status;
  });

  return (
    <div className="container mt-1">
      <div className="p-5 bg-light rounded shadow-sm">
        <h4 className="text-primary mb-4">Driver App </h4>

        {filteredTickets.length > 0 ? (
          <>
            <div className="mb-2">
              {access === "Edit" && (
                <button
                  className="btn btn-primary mt-1"
                  onClick={handleSaveChanges}
                  aria-label="Save changes"
                >
                  Save Changes
                </button>
              )}
            </div>
            <div className="table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Location</th>
                    <th>Reservation Number</th>
                    <th>Customer Name</th>
                    <th>Terminal</th>
                    <th>Pickup Point</th>
                    <th>Requested Date & Time</th>
                    <th>Ticket Status</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredTickets.map((ticket) => (
                    <tr key={ticket._id} id={`ticket-${ticket._id}`}>
                      <td data-label="Location">
                        {ticket.locationId.split("-")[1]}
                      </td>
                      <td data-label="Reservation Number">
                        {ticket.reservationNumber}
                      </td>
                      <td data-label="Customer Name">{ticket.customer_name}</td>
                      <td data-label="Terminal">{ticket.selectedTerminal}</td>
                      <td data-label="Pillar Number">
                        {ticket.selectedPillar}
                      </td>
                      <td data-label="Requested Date & Time">
                        {formatDate_withTime(new Date(ticket.requested_date))}
                      </td>
                      <td data-label="Ticket Status">
                        <select
                          className="form-select"
                          aria-label="Ticket Status Select"
                          value={
                            editedTickets[ticket._id] ||
                            (ticket.ticket_status ? "Requested" : "Completed")
                          }
                          onChange={(e) =>
                            handleStatusChange(ticket._id, e.target.value)
                          }
                        >
                          <option value="Requested">Requested</option>
                          <option value="Completed">Completed</option>
                        </select>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        ) : (
          <div className="pt-3">
            {userType === "SuperAdmin"
              ? "Permissions: Viewing this data requires Driver level access. However, you can still access all open tickets via the Request Tracking Screen."
              : "Currently, there are no outstanding ticket requests."
        
              }
          </div>
        )}
      </div>
    </div>
  );
}

export default RequestVehicle;
